import DotIndicator from "../../../../../ui/dotindicator/dotindicator";
import * as React from "react";
import Button from "../../../../../core/button/button";
import "./tab1.scss";
import DatePicker from "../../../../../ui/datepicker/datepicker";
import Alert from "../../../../../ui/alert/alert";

const Tab1 = () => {
    return (
        <div className="Tab1">
            <div className="row">
                <div className="d-flex align-items-center mb-4">
                    <DotIndicator/>
                    <span>درخواست مشاوره</span>
                </div>
                <p style={{marginTop: '-13px'}} className="font-light gray-text">این متن برای توضیحات مربوط به دانلود
                    اپلیکیشن است که کاربر را راهنمایی کند.</p>
                <div className="row">
                    <div className="col-lg-6 col-md-6 col-12 mb-3 mt-2">
                        <label htmlFor="name">نام و نام خانوادگی</label>
                        <input type="text" name="name" id="name" className="Campaign-Input mt-2"
                               placeholder="وارد کنید"/>
                    </div>
                    <div className="col-lg-6 col-md-6 col-12 mb-3 mt-2">
                        <label htmlFor="email">ایمیل</label>
                        <input type="email" name="email" id="email" className="Campaign-Input mt-2"
                               placeholder="مثال: example@gmail.com"/>
                    </div>
                    <div className="col-lg-6 col-md-6 col-12 mb-3 mt-2">
                        <label htmlFor="tel">شماره تماس</label>
                        <input type="tel" name="tel" id="tel" className="Campaign-Input mt-2"
                               placeholder="وارد کنید"/>
                    </div>
                    <div className="col-lg-6 col-md-6 col-12 mb-3 mt-2">
                        <label htmlFor="name">تاریخ مشاوره</label>
                        <div className="d-flex justify-content-end align-items-center Date-Picker-Box">
                            <DatePicker/>
                            <Button type={"secondary"} action={() => {

                            }} responsive={false}>انتخاب تاریخ</Button>
                        </div>
                    </div>
                    <div className="col-lg-6 col-md-6 col-12 mb-3 mt-2">
                        <Alert type={"Info"}>
                            کارشناس تا ۴۸ ساعت آینده با شما تماس می گیرد.
                        </Alert>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Tab1;